
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Feedback } from './models/feedback.model';
import { FeedbackService } from './feedback.service';
import { EventLoggerService } from './event-logger.service';
import { ErrorManagerService } from './error-handling/error-manager.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class FeedbackServiceImpl implements FeedbackService {

    constructor(private http: Http, private eventLoggerService: EventLoggerService, private errorManager: ErrorManagerService, private configService: ConfigurationService) { }

    submit(feedback: Feedback) {
        const headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        const options = new RequestOptions({ headers: headers });
        const url: string = this.configService.configuration.feedbackUri;

        this.http.post(url, feedback, options)
            // .map(this.processResponse)
            // .catch(x => this.handleError(x))
            .subscribe();
    }

    // private processResponse(response: Response) {
    //    console.log("processResponse");
    //    if (response.status < 200 || response.status >= 300) {
    //        var error = new Error(response.status.toString() + ':' + response.json());
    //        this.eventLoggerService.logError(error, "Error in FeedbackService", {});
    //        if (!this.errorManager.handleError(error, error.name, "", error.message)) {
    //            return Observable.throw(error);
    //        }
    //    }

    //    let body = response.json();
    //    return body.items || {};
    // }

    // private handleError(error: Error): Promise<any> {
    //     this.errorManager.handleError(error, error.name, "", error.message);
    //     return Promise.reject(error.message || error);
    // }
}



// WEBPACK FOOTER //
// ./src/app/shared/feedback-impl.service.ts